import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { SquareLoader } from "react-spinners";

import { applyAuthResponse, verifyEmail } from "../../api/auth";
import AuthContext from "../../contexts/AuthCtx";
import AuthLayout from "../../components/UX/AuthLayout";
import { loginFromResponse } from "../../utils/authRedirect";
import { captureEvent, identifyUser } from "../../analytics";

function VerifyEmail() {
  const { token } = useParams();
  const AuthCtx = useContext(AuthContext);
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const run = async () => {
      if (!token) {
        setError("Lien de vérification invalide ou expiré.");
        setLoading(false);
        return;
      }

      try {
        const response = await verifyEmail(token);
        if (cancelled) return;

        const data = applyAuthResponse(response);
        if (data.isNewAccount) {
          captureEvent("account_created", {
            method: "email_password",
            email: data.user?.email,
          });
        }
        identifyUser({
          id: data.user?._id,
          email: data.user?.email,
          userStatus: data.user?.userStatus,
          userRole: data.user?.userRole,
        });
        loginFromResponse(AuthCtx, data, navigate);
      } catch (err) {
        if (cancelled) return;
        setError(
          err.response?.data?.message ||
            "Lien de vérification invalide ou expiré."
        );
        setLoading(false);
      }
    };

    run();
    return () => {
      cancelled = true;
    };
  }, [AuthCtx, navigate, token]);

  if (loading) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-white">
        <SquareLoader size={80} color="#823779" loading />
      </div>
    );
  }

  return (
    <AuthLayout
      headerLink={
        <>
          <Link to="/login" className="text-primaryText underline">
            Se connecter
          </Link>
        </>
      }
    >
      <div className="text-center flex flex-col gap-4">
        <h1 className="font-logo text-3xl md:text-4xl text-black">
          Vérification impossible
        </h1>
        <p className="font-josefin text-secondaryText text-sm md:text-base">
          {error}
        </p>
        <p className="font-josefin text-sm text-secondaryText">
          Tu peux{" "}
          <Link to="/signup" className="text-primaryText underline">
            créer un nouveau compte
          </Link>{" "}
          ou{" "}
          <Link to="/login" className="text-primaryText underline">
            te connecter
          </Link>
          .
        </p>
      </div>
    </AuthLayout>
  );
}

export default VerifyEmail;
